// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file html_template_service.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { HtmlTemplate } from "./html_template_pb";
import { file_html_template } from "./html_template_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file html_template_service.proto.
 */
export const file_html_template_service: GenFile = /*@__PURE__*/
  fileDesc("ChtodG1sX3RlbXBsYXRlX3NlcnZpY2UucHJvdG8SC2dycGMuYXBpLnYxIkYKE0h0bWxUZW1wbGF0ZVJlcXVlc3QSLwoMaHRtbFRlbXBsYXRlGAEgASgLMhkuZ3JwYy5hcGkudjEuSHRtbFRlbXBsYXRlIiMKFUh0bWxUZW1wbGF0ZUlkUmVxdWVzdBIKCgJpZBgCIAEoAyIZChdIdG1sVGVtcGxhdGVMaXN0UmVxdWVzdCJHChRIdG1sVGVtcGxhdGVSZXNwb25zZRIvCgxodG1sVGVtcGxhdGUYASABKAsyGS5ncnBjLmFwaS52MS5IdG1sVGVtcGxhdGUiSwoYSHRtbFRlbXBsYXRlTGlzdFJlc3BvbnNlEi8KDGh0bWxUZW1wbGF0ZRgBIAEoCzIZLmdycGMuYXBpLnYxLkh0bWxUZW1wbGF0ZTKpAwoTSHRtbFRlbXBsYXRlU2VydmljZRJMCgNnZXQSIi5ncnBjLmFwaS52MS5IdG1sVGVtcGxhdGVJZFJlcXVlc3QaIS5ncnBjLmFwaS52MS5IdG1sVGVtcGxhdGVSZXNwb25zZRJNCgZjcmVhdGUSIC5ncnBjLmFwaS52MS5IdG1sVGVtcGxhdGVSZXF1ZXN0GiEuZ3JwYy5hcGkudjEuSHRtbFRlbXBsYXRlUmVzcG9uc2USTQoGdXBkYXRlEiAuZ3JwYy5hcGkudjEuSHRtbFRlbXBsYXRlUmVxdWVzdBohLmdycGMuYXBpLnYxLkh0bWxUZW1wbGF0ZVJlc3BvbnNlEk8KBmRlbGV0ZRIiLmdycGMuYXBpLnYxLkh0bWxUZW1wbGF0ZUlkUmVxdWVzdBohLmdycGMuYXBpLnYxLkh0bWxUZW1wbGF0ZVJlc3BvbnNlElUKBGxpc3QSJC5ncnBjLmFwaS52MS5IdG1sVGVtcGxhdGVMaXN0UmVxdWVzdBolLmdycGMuYXBpLnYxLkh0bWxUZW1wbGF0ZUxpc3RSZXNwb25zZTABQgZaBC47cGJiBnByb3RvMw", [file_html_template]);

/**
 * @generated from message grpc.api.v1.HtmlTemplateRequest
 */
export type HtmlTemplateRequest = Message<"grpc.api.v1.HtmlTemplateRequest"> & {
  /**
   * @generated from field: grpc.api.v1.HtmlTemplate htmlTemplate = 1;
   */
  htmlTemplate?: HtmlTemplate | undefined;
};

/**
 * Describes the message grpc.api.v1.HtmlTemplateRequest.
 * Use `create(HtmlTemplateRequestSchema)` to create a new message.
 */
export const HtmlTemplateRequestSchema: GenMessage<HtmlTemplateRequest> = /*@__PURE__*/
  messageDesc(file_html_template_service, 0);

/**
 * @generated from message grpc.api.v1.HtmlTemplateIdRequest
 */
export type HtmlTemplateIdRequest = Message<"grpc.api.v1.HtmlTemplateIdRequest"> & {
  /**
   * @generated from field: int64 id = 2;
   */
  id: bigint;
};

/**
 * Describes the message grpc.api.v1.HtmlTemplateIdRequest.
 * Use `create(HtmlTemplateIdRequestSchema)` to create a new message.
 */
export const HtmlTemplateIdRequestSchema: GenMessage<HtmlTemplateIdRequest> = /*@__PURE__*/
  messageDesc(file_html_template_service, 1);

/**
 * @generated from message grpc.api.v1.HtmlTemplateListRequest
 */
export type HtmlTemplateListRequest = Message<"grpc.api.v1.HtmlTemplateListRequest"> & {
};

/**
 * Describes the message grpc.api.v1.HtmlTemplateListRequest.
 * Use `create(HtmlTemplateListRequestSchema)` to create a new message.
 */
export const HtmlTemplateListRequestSchema: GenMessage<HtmlTemplateListRequest> = /*@__PURE__*/
  messageDesc(file_html_template_service, 2);

/**
 * @generated from message grpc.api.v1.HtmlTemplateResponse
 */
export type HtmlTemplateResponse = Message<"grpc.api.v1.HtmlTemplateResponse"> & {
  /**
   * @generated from field: grpc.api.v1.HtmlTemplate htmlTemplate = 1;
   */
  htmlTemplate?: HtmlTemplate | undefined;
};

/**
 * Describes the message grpc.api.v1.HtmlTemplateResponse.
 * Use `create(HtmlTemplateResponseSchema)` to create a new message.
 */
export const HtmlTemplateResponseSchema: GenMessage<HtmlTemplateResponse> = /*@__PURE__*/
  messageDesc(file_html_template_service, 3);

/**
 * @generated from message grpc.api.v1.HtmlTemplateListResponse
 */
export type HtmlTemplateListResponse = Message<"grpc.api.v1.HtmlTemplateListResponse"> & {
  /**
   * @generated from field: grpc.api.v1.HtmlTemplate htmlTemplate = 1;
   */
  htmlTemplate?: HtmlTemplate | undefined;
};

/**
 * Describes the message grpc.api.v1.HtmlTemplateListResponse.
 * Use `create(HtmlTemplateListResponseSchema)` to create a new message.
 */
export const HtmlTemplateListResponseSchema: GenMessage<HtmlTemplateListResponse> = /*@__PURE__*/
  messageDesc(file_html_template_service, 4);

/**
 * @generated from service grpc.api.v1.HtmlTemplateService
 */
export const HtmlTemplateService: GenService<{
  /**
   * @generated from rpc grpc.api.v1.HtmlTemplateService.get
   */
  get: {
    methodKind: "unary";
    input: typeof HtmlTemplateIdRequestSchema;
    output: typeof HtmlTemplateResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.HtmlTemplateService.create
   */
  create: {
    methodKind: "unary";
    input: typeof HtmlTemplateRequestSchema;
    output: typeof HtmlTemplateResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.HtmlTemplateService.update
   */
  update: {
    methodKind: "unary";
    input: typeof HtmlTemplateRequestSchema;
    output: typeof HtmlTemplateResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.HtmlTemplateService.delete
   */
  delete: {
    methodKind: "unary";
    input: typeof HtmlTemplateIdRequestSchema;
    output: typeof HtmlTemplateResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.HtmlTemplateService.list
   */
  list: {
    methodKind: "server_streaming";
    input: typeof HtmlTemplateListRequestSchema;
    output: typeof HtmlTemplateListResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_html_template_service, 0);

